export default "__VITE_ASSET__D2Hq6IS5__"